import { Session, Site } from 'webportalclient';
import * as Moment from "moment";
import { Permission } from '../../../misc/api/apiTypes';

export const SiteOptionsSelector = (currentPermissions: Permission[], siteOptions: Site[]): Array<Site> => {
    if (currentPermissions.length > 0 && siteOptions.length > 0) {
        return siteOptions.sort((a, b) => a.number.localeCompare(b.number));
    } else {
        return [];
    }
}

export const GetSessionLabel = (s: Session) => `${s.name} - ${Moment.parseZone(s.occurred).format("DD-MMM-YYYY HH:mm:ss")} ${s.suppressed ? "(Suppressed)" : "" }`
